import { useTemplates } from './use-templates.query';
import type { Template } from '@/api/v4/template.api';
import { InfiniteScrollTable } from '@/ui/table/infinite-table/infinite-scroll-table';
import { useTemplatesTableConfiguration } from './templates-table/use-templates-table-configuration';
import type { TemplateSortKey } from './account-management.state';
import { templatesSortState } from './account-management.state';
import { INFINITE_TABLE_ROW_HEIGHT } from '@/ui/table/infinite-table/table-body';

export const ManageTemplates = () => {
  const { data = [], isLoading } = useTemplates();

  const { rows, header } = useTemplatesTableConfiguration();

  return (
    <InfiniteScrollTable<Template, TemplateSortKey>
      id="templates"
      data={data}
      isLoading={isLoading}
      sortState={templatesSortState}
      hasMore={false}
      headers={header}
      rows={rows}
      height={`${INFINITE_TABLE_ROW_HEIGHT * 4}px`}
    />
  );
};
